import { DefaultRequest } from 'scripts/api';

Greenmile.RouteSummary = Greenmile.RouteSummary || {};
Greenmile.RouteSummary.SKUs = Greenmile.RouteSummary.SKUs || {};
Greenmile.RouteSummary.SKUs.Grid = Greenmile.RouteSummary.SKUs.Grid || {};

Greenmile.RouteSummary.SKUs.Grid = function () {
  this.entity = null;
  this.containerGrid = null;
  this.gridActionsSelector = null;
  this.entityToActionGrid = null;

  this.countCustomColumns = 0;
  this.defaultFilters = {};

  this.gridColumnFormatter = function (row, cell, value) {
    if (value?.$display === null) {
      return '';
    }

    return value?.$display ? value?.$display : value;
  };

  this.show = function () {
    const options = {
      entity: this.entity,
      columnCheckBox: {
        show: false
      },
      selectorToGridActions: this.gridActionsSelector,
      entityToActionGrid: this.entityToActionGrid,
      gridContainner: this.containerGrid,
      columnEdit: {
        show: false
      },
      headerMenu: {
        headerMenuEventClass: Monet.Grid.ActionsModules.MenuShowTotals
      },
      multiColumnSort: true,
      rowHeight: 30,
      sortBy: 'client'
    };

    try {
      const router = new App.Routers[this.entity]();

      const filterBuilder = new Monet.UI.FilterBuilder();
      filterBuilder.setFieldsOverride({
        RATING: 'INTEGER',
        TEXT_AREA: 'TEXT'
      });

      const controlUpdate = new Monet.Grid.ControlUpdate();

      const executeFilter = () => {
        Monet.Grid.Utils.clearPagination(this.entity);
        router.updateGrid(router.getFilter(), Monet.Grid.addDataToGrid);
      };

      const afterSaveListCallback = () => {
        Monet.Grid.Utils.clearPagination(this.entity);
        App.Forms[this.entity].layout = {};

        const createdFilterBuilder = App.Forms[this.entity].filterBuilder;

        createdFilterBuilder.updateValuesSelectedFilters();
        createdFilterBuilder.saveState();

        this.show();
      };

      const buildFilterBuilder = () => {
        filterBuilder.setEntity(this.entityToActionGrid);
        filterBuilder.setSelector(this.containerGrid);
        filterBuilder.setCustomNameSpace(this.entity);
        filterBuilder.setIdScreen(`RouteSummary`);
        filterBuilder.setDefaultFilters(this.defaultFilters);
        filterBuilder.customRequest = executeFilter;
        filterBuilder.selectorContainerFilter = this.gridActionsSelector;
        filterBuilder.render();

        App.Forms[this.entity].filterBuilder = filterBuilder;

      };

      buildFilterBuilder();

      controlUpdate.setEntityToNamespace(this.entity);

      const customizeColumns = new Monet.Grid.ActionsModules.CustomizeColumns();
      const exportFormats = new Monet.Grid.ActionsModules.ExportFormats();
      const saveGridLayout = new Monet.Grid.ActionsModules.SaveGridLayout();

      const element = document.querySelector(this.gridActionsSelector);

      if (!element) return;

      const monetUIGridActions = document.createElement("div");
      monetUIGridActions.setAttribute('class', "MonetUIGridActions");

      element.innerHTML = '';
      element.appendChild(filterBuilder.el);
      element.appendChild(monetUIGridActions);

      customizeColumns.setEntity(this.entityToActionGrid);
      customizeColumns.setScreenName(this.entity);
      customizeColumns.setSelector(this.gridActionsSelector);
      customizeColumns.setElement(monetUIGridActions);

      customizeColumns.setCallBacks({
        afterSaveList: afterSaveListCallback
      });

      exportFormats.setEntity(this.entityToActionGrid);
      exportFormats.setScreenName(this.entity);
      exportFormats.setSelector(this.gridActionsSelector);
      exportFormats.setElement(monetUIGridActions);
      exportFormats.saveFieldList = () => {
        exportFormats.handlerToggleLoadingInBtn();

        const fields = exportFormats.getFieldsSelecteds();
        const parsedFields = fields.map(field => field.replace(/"/g, ''));
        const formFields = App.Forms[this.entity].fields;
        const getValuesFromModel = (modelField) =>
          typeof modelField === 'object'
            ? modelField['$display'] || ''
            : modelField || '';
        const csvHeader = Object.values(parsedFields).map(field => formFields[field].translatedLabel).join(',');
        const formattedData = App.Forms[this.entity].dataProvider.data
          .map((item) => {
            return parsedFields
              .map((field) => {
                const modelField = item.model.attributes[field];
                return getValuesFromModel(modelField).replace(
                  /,/g,
                  '.'
                );
              })
              .join(',');
          })
          .join('\n');

        const csvContent = `${csvHeader} \n ${formattedData}`;
        const data = new Blob([csvContent], { type: 'text/csv;encoding:utf-8' });

        const date = new Date();
        const fileName = `${this.entity}_${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}.csv`;

        const isInternetExplorer = navigator.userAgent.indexOf('MSIE') !== -1 || navigator.userAgent.indexOf('Trident') !== -1;
        const link = document.createElement('a');

        document.body.appendChild(link);

        if (isInternetExplorer) {
          if (navigator.userAgent.indexOf('MSIE 9.0') > 0) {
            const newBrowserWindow = window.open('about:blank', '_blank', 'noopener,noreferrer');
            newBrowserWindow.document.write(data);
            newBrowserWindow.document.close();
            newBrowserWindow.document.execCommand('SaveAs', true, fileName);
            newBrowserWindow.close();
            document.body.removeChild(link);
          } else {
            link.addEventListener('click', () => {
              navigator.msSaveBlob(data, fileName);
              document.body.removeChild(link);
            }, false);
          }
        } else {
          link.href = URL.createObjectURL(data);
          link.download = fileName;
          document.body.removeChild(link);
        }

        link.click();

        exportFormats.inProgress = false;
        exportFormats.handlerToggleLoadingInBtn();
        exportFormats.togglePopUp();
      };
      exportFormats.retrieveAllColumnsFromEntity = function (callback) {
        const that = this;

        const request = new DefaultRequest({
          url: "form/" + that.entity + "/Fields",
          success: function (data) {
            callback(data, that.entity, that.selector, that.screenName);
          }
        });
        request.send();
      };

      saveGridLayout.setEntity(this.entityToActionGrid);
      saveGridLayout.setScreenName(this.entity);
      saveGridLayout.setSelector(this.gridActionsSelector);
      saveGridLayout.setElement(monetUIGridActions);

      saveGridLayout.setCallBacks({
        afterSaveList: afterSaveListCallback
      });

      filterBuilder.postRender();

      exportFormats.init();
      customizeColumns.init();
      saveGridLayout.init();

      this.getColumns(function (columnsLoaded) {
        let columns = columnsLoaded || Monet.Grid.getGridLayout(App.Forms[this.entity].layout.index, this.entity);

        const parsedColumns = columns.map(column => ({
          ...column,
          formatter: this.gridColumnFormatter
        }));

        const dataView = new Monet.Grid.DataProvider(parsedColumns, null, this.entity);
        const grid = new Monet.Grid.GenericGrid(this.containerGrid, dataView, parsedColumns, options);

        const columnDefault = App.Forms[this.entity].columnToOrders;
        let columnSortDefault = [];

        if (columnDefault) {
          const sizeColumnDefault = columnDefault.length;

          for (let i = 0; i < sizeColumnDefault; i++) {
            const columnToSort = grid.getColumnByFieldName(columnDefault[i].field);
            const sort = columnDefault[i].order === 'ASC';

            if (columnToSort) {
              columnSortDefault.push({ columnId: columnToSort.id, sortAsc: sort });
            }
          }

          if (columnSortDefault.length) {
            grid.setSortColumns(columnSortDefault);
          }
        }

        App.Forms[this.entity].table = grid;
        App.Forms[this.entity].dataProvider = dataView;
        App.Forms[this.entity].controlUpdater = controlUpdate;

        executeFilter();

        if (this.afterShow) {
          this.afterShow();
        }
      }.bind(this));

    } catch (e) {
      new Monet.Exception.ReturnError(this, `Error on show grid on ${this.entity} monitoring.`, e).console();
    }

  };

  this.getColumns = function (callback) {
    try {
      if (!App.Forms[this.entity].layout) {
        App.Forms[this.entity].layout = {};
      }

      if (!App.Forms[this.entity].layout.index) {
        const route = new App.Routers[this.entity]();
        route.getFieldsToGridLayout(callback);
      } else {
        callback();
      }

    } catch (e) {
      new Monet.Exception.ReturnError(this,
        `Error on get  columns to ${this.entity} on route monitoring.`, e).console();
    }

  };

  this.init = function () {
    const dataMapper = new Monet.Builder.DataMapper();

    const callback = () => {
      dataMapper.copyDataMapperToAnotherNamespace(this.entity);
      this.show();
    };

    dataMapper.setEntity(this.entityToActionGrid);
    dataMapper.build(callback);
  }

  return this;

};

